/* eslint-disable no-unused-vars */

// Language labels for multilingual support
const LABELS = {
  'en': {
    loading: 'Loading...',
    error: 'Error loading content.'
  },
  'de-DE': {
    loading: 'Lade...',
    error: 'Fehler beim Laden des Inhalts.'
  }
};

// Function to get current page language
function getPageLanguage() {
  // Check the lang attribute in HTML tag
  const htmlLang = document.documentElement.lang || 'en';

  // Return the language code if supported, otherwise fallback to English
  return LABELS[htmlLang] ? htmlLang : 'en';
}

function initSmallLayoutAnimations() {
  // Standard top link animation
  $('.top-link').on('click', () => {
    $('body,html').animate({
      scrollTop: 0,
    }, 800);
  });
}

window.addEventListener('scroll', function(){
  const progressBar = document.getElementById("progressBar");
  if (!progressBar) {
    return;
  }

  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  const scrolled = (scrollTop / docHeight) * 100;
  progressBar.style.width = `${scrolled}%`;
});


$(document).ready(function() {
  // Get current language
  const currentLang = getPageLanguage();
  const labels = LABELS[currentLang];

  // Event handler for glossary links
  $('.dpnglossary.link').on('click', function(e) {
    e.preventDefault(); // Prevents normal navigation

    const url = $(this).attr('href');
    const $link = $(this);

    // Check if tooltip already exists
    if ($link.next('.ajax-tooltip').length > 0) {
      $link.next('.ajax-tooltip').toggle();
      return;
    }

    // Display loading indicator
    $link.after(`<span class="ajax-tooltip loading">${labels.loading}</span>`);

    // AJAX request
    $.ajax({
      url: url,
      method: 'GET',
      dataType: 'html',
      success: function(data) {
        // Extract div.tooltip from response
        const $response = $(data);
        const tooltipContent = $response.find('div.tooltip').html();

        // Remove loading indicator and show tooltip content
        $link.next('.ajax-tooltip').removeClass('loading').html(tooltipContent);

      },
      error: function(xhr, status, error) {
        $link.next('.ajax-tooltip').removeClass('loading')
            .html(`<p>${labels.error}</p>`);
        console.error('AJAX Error:', error);
      }
    });
  });

  // Event handler for close button
  $(document).on('click', '.tooltip-close', function() {
    $(this).closest('.ajax-tooltip').remove();
  });

  // Close tooltip when clicking outside
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.dpnglossary.link, .ajax-tooltip').length) {
      $('.ajax-tooltip').remove();
    }
  });
});
